import { PickemDetailsBase } from "model/PickemDetails/PickemDetails";
import { MatchemDetails } from "model/PickemDetails/Matchem/Details";
import { mapMatchemPointsRules } from "./FsMatchemPointsRules";
import { FsMatchemDetails } from "db/model/pickemDetails/Matchem/FsMatchemDetails";

export const mapMatchemDetails = (
  fsModel: FsMatchemDetails,
  base: PickemDetailsBase
): MatchemDetails | undefined => {
  if (!fsModel.pointsRules) {
    return undefined;
  }

  const pointsRules = mapMatchemPointsRules(fsModel.pointsRules);
  if (!pointsRules) {
    return undefined;
  }

  return {
    ...base,
    pointsRules,
    subSegmentNum: fsModel.subSegmentNum,
  };
};
